import ComparisonSummary from './ComparisonSummary';
import ComparisonSummaryBuildings from './ComparisonSummaryBuildings';
import ComparisonSummaryDwellingAddress from './ComparisonSummaryDwellingAddress';
import ComparisonSummaryDwellingDetails from './ComparisonSummaryDwellingDetails';
import ComparisonSummaryDwellingLimits from './ComparisonSummaryDwellingLimits';
import ComparisonSummaryEntities from './ComparisonSummaryEntities';
import ComparisonSummaryEntity from './ComparisonSummaryEntity';
import ComparisonSummaryInsuredInfo from './ComparisonSummaryInsuredInfo';
import ComparisonSummaryMortgagees from './ComparisonSummaryMortgagees';
import ComparisonSummaryPerilDeductible from './ComparisonSummaryPerilDeductible';
import ComparisonSummaryPerilsDeductibles from './ComparisonSummaryPerilsDeductibles';

export {
	ComparisonSummary,
	ComparisonSummaryBuildings,
	ComparisonSummaryDwellingAddress,
	ComparisonSummaryDwellingDetails,
	ComparisonSummaryDwellingLimits,
	ComparisonSummaryEntities,
	ComparisonSummaryEntity,
	ComparisonSummaryInsuredInfo,
	ComparisonSummaryMortgagees,
	ComparisonSummaryPerilDeductible,
	ComparisonSummaryPerilsDeductibles,
};